import { idaho } from './Idaho';
import { minnesota_fs } from './Minnesota_fs';
import { minnesota } from './Minnesota';
import { nevada } from './Nevada';
import { newjersy } from './NewJersy';
import { newmexico } from './NewMexico';
import { oregon } from './Oregon';
import { pennsylvania } from './Pennsylvania';
import { georgia } from './Georgia';
import { virginia } from './Virginia';
import { illinois } from './Illinois';
import { getinsured } from './GetInsured';
import { IEX_STATE_CODES } from '@constants/configs/states';

export const headerConfig = {
    [IEX_STATE_CODES.ID]: () => idaho,
    [IEX_STATE_CODES.MN]: (isMNFullStack) => isMNFullStack ? minnesota_fs : minnesota,
    [IEX_STATE_CODES.NV]: () => nevada,
    [IEX_STATE_CODES.NJ]: () => newjersy,
    [IEX_STATE_CODES.NM]: () => newmexico,
    [IEX_STATE_CODES.OR]: () => oregon,
    [IEX_STATE_CODES.PA]: () => pennsylvania,
    [IEX_STATE_CODES.GA]: () => georgia,
    [IEX_STATE_CODES.VA]: () => virginia,
    [IEX_STATE_CODES.IL]: () => illinois,
    [IEX_STATE_CODES.GI]: () => getinsured

};